/** biome-ignore-all lint/suspicious/noBitwiseOperators: Intentional */
export const createEncoder = (alphabet: string) => {
	const bitCount = Math.log2(alphabet.length)
	if (bitCount !== Math.floor(bitCount)) {
		throw new Error('Invalid alphabet, must be a power of two characters')
	}

	const lookup = Object.fromEntries(alphabet.split('').map((value, index) => [value, index] as const))

	const encodeMask = (1 << bitCount) - 1
	const decodeMask = (1 << 8) - 1

	return {
		encode: (input: Uint8Array) => {
			let output = ''
			let remainder = 0
			let bits = 0
			for (const byte of input) {
				bits += 8
				let value = (remainder << 8) + byte
				while (bits >= bitCount) {
					bits -= bitCount
					output += alphabet[value >> bits]
					value &= ~(encodeMask << bits)
				}
				remainder = value
			}

			if (bits > 0) {
				output += alphabet[remainder << (bitCount - bits)]
			}

			return output
		},
		decode: (input: string) => {
			const size = Math.floor((input.length * bitCount) / 8)
			const output = new Uint8Array(size)

			let remainder = 0
			let position = 0
			let bits = 0

			for (const character of input) {
				if (!(character in lookup)) {
					throw new Error(`Invalid character '${character}' (${character.charCodeAt(0)}) in input`)
				}

				bits += bitCount
				let value = (remainder << bitCount) + lookup[character]
				if (bits >= 8) {
					bits -= 8
					output[position++] = value >> bits
					value &= ~(decodeMask << bits)
				}
				remainder = value
			}

			return output
		},
	}
}

export const base32 = createEncoder('abcdefghijkmnpqrstuvwxyz23456789')
